module.exports = __webpack_public_path__ + "img/SG.2d6223ae.svg";